// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-buscar-prontuario{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-transform: uppercase;
}

.prontuario-actions-top{
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-limpar-prontuario{
  background: #fff;
  border: 1px solid var(--ui-border);
  color: var(--ui-primary);
}
.btn-buscar-prontuario img{
  width: 15px;
  height: auto;
}

.prontuario-results {
  margin-top: 16px;
}

.prontuario-error {
  color: #b00020;
  font-weight: 600;
}

.prontuario-loading,
.prontuario-empty {
  color: #4b5563;
}

.prontuario-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 12px;
}

.prontuario-card {
  border: 1px solid #e7ebf5;
  border-radius: 12px;
  padding: 12px;
  background: #f8f9ff;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prontuario-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.prontuario-name {
  margin: 0;
  font-weight: 700;
  color: #2c3a4b;
  word-break: break-word;
}

.prontuario-mime {
  font-size: 12px;
  color: #556274;
  background: #e7ebf5;
  padding: 4px 8px;
  border-radius: 8px;
}

.prontuario-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #3a4a70;
  font-size: 14px;
}

.prontuario-actions {
  display: flex;
  justify-content: flex-start;
}

.btn-download {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.btn-download:hover {
  background: #1d4ed8;
}

.btn-buscar-prontuario>strong{
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PesquisaProntuario/prontuario.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".btn-buscar-prontuario{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  text-transform: uppercase;\n}\n\n.prontuario-actions-top{\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.btn-limpar-prontuario{\n  background: #fff;\n  border: 1px solid var(--ui-border);\n  color: var(--ui-primary);\n}\n.btn-buscar-prontuario img{\n  width: 15px;\n  height: auto;\n}\n\n.prontuario-results {\n  margin-top: 16px;\n}\n\n.prontuario-error {\n  color: #b00020;\n  font-weight: 600;\n}\n\n.prontuario-loading,\n.prontuario-empty {\n  color: #4b5563;\n}\n\n.prontuario-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 12px;\n}\n\n.prontuario-card {\n  border: 1px solid #e7ebf5;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8f9ff;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prontuario-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.prontuario-name {\n  margin: 0;\n  font-weight: 700;\n  color: #2c3a4b;\n  word-break: break-word;\n}\n\n.prontuario-mime {\n  font-size: 12px;\n  color: #556274;\n  background: #e7ebf5;\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n\n.prontuario-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #3a4a70;\n  font-size: 14px;\n}\n\n.prontuario-actions {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.btn-download {\n  background: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.btn-download:hover {\n  background: #1d4ed8;\n}\n\n.btn-buscar-prontuario>strong{\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
